import React from 'react';

export const SuccessIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="7"
        fill="white"
        stroke="#8DD981"
        strokeWidth="2"
      />
      <path
        d="M11 6L6.875 10.125L5 8.25"
        stroke="#8DD981"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
